import { CustomerClassifications as CustomerClassificationsEnum } from '@mews-commander/data-access';
import { enumify, Enumify, EnumValue } from '@mews/enumify';

function CustomerClassifications() {}

const config = {
    PaymasterAccount: 2 ** 0,
    Blacklist: 2 ** 1,
    Media: 2 ** 2,
    LoyaltyProgram: 2 ** 3,
    PreviousComplaint: 2 ** 4,
    Returning: 2 ** 5,
    Staff: 2 ** 6,
    FriendOrFamily: 2 ** 7,
    TopManagement: 2 ** 8,
    Important: 2 ** 9,
    VeryImportant: 2 ** 10,
    Problematic: 2 ** 11,
    Cashlist: 2 ** 12,
    DisabledPerson: 2 ** 13,
    Military: 2 ** 14,
    Airline: 2 ** 15,
    HealthCompliant: 2 ** 16,
    InRoom: 2 ** 17,
    WaitingForRoom: 2 ** 18,
    Student: 2 ** 19,
};
enumify<CustomerClassificationsEnum, number>(CustomerClassifications, 'CustomerClassifications', config);

export type CustomerClassificationValue = EnumValue<CustomerClassificationsEnum, number>;

export default CustomerClassifications as unknown as Enumify<CustomerClassificationsEnum, number>;
